var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8933 0H2.66667C1.2 0 0 1.2 0 2.66667V21.3333C0 22.8 1.2 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V9.10667C24 8.4 23.72 7.72 23.2133 7.22667L16.7733 0.786667C16.28 0.28 15.6 0 14.8933 0ZM6.66667 16H17.3333C18.0667 16 18.6667 16.6 18.6667 17.3333C18.6667 18.0667 18.0667 18.6667 17.3333 18.6667H6.66667C5.93333 18.6667 5.33333 18.0667 5.33333 17.3333C5.33333 16.6 5.93333 16 6.66667 16ZM6.66667 10.6667H17.3333C18.0667 10.6667 18.6667 11.2667 18.6667 12C18.6667 12.7333 18.0667 13.3333 17.3333 13.3333H6.66667C5.93333 13.3333 5.33333 12.7333 5.33333 12C5.33333 11.2667 5.93333 10.6667 6.66667 10.6667ZM6.66667 5.33333H13.3333C14.0667 5.33333 14.6667 5.93333 14.6667 6.66667C14.6667 7.4 14.0667 8 13.3333 8H6.66667C5.93333 8 5.33333 7.4 5.33333 6.66667C5.33333 5.93333 5.93333 5.33333 6.66667 5.33333Z",
    fill: "#1777CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.ce9ce63412e44d4fe7efe93d1777e23a.svg";
export { ForwardRef as ReactComponent };